var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "box"
  }, [_c('h1', {
    staticClass: "page-header"
  }, [_vm._v("\n      Property Information\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "columns is-multiline"
  }, [_c('div', {
    staticClass: "column is-half"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Property Owner Full Name")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Request.PropertyOwnerName),
      expression: "Request.PropertyOwnerName"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Enter Property Owner Full Name"
    },
    domProps: {
      "value": (_vm.Request.PropertyOwnerName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Request, "PropertyOwnerName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Property Address")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Request.PropertyAddress),
      expression: "Request.PropertyAddress"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Enter Property Address"
    },
    domProps: {
      "value": (_vm.Request.PropertyAddress)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Request, "PropertyAddress", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Loan Number")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Request.LoanNumber),
      expression: "Request.LoanNumber"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Enter Loan Number"
    },
    domProps: {
      "value": (_vm.Request.LoanNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Request, "LoanNumber", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Certificate Holder")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Request.CertificateHolder),
      expression: "Request.CertificateHolder"
    }],
    staticClass: "textarea",
    staticStyle: {
      "resize": "none"
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter Lender Certificiate Holder Information"
    },
    domProps: {
      "value": (_vm.Request.CertificateHolder)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Request, "CertificateHolder", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "column is-half"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Association Name")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Request.Association.Name),
      expression: "Request.Association.Name"
    }],
    staticClass: "input",
    attrs: {
      "disabled": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.Request.Association.Name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Request.Association, "Name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _vm._m(0), _vm._v(" "), (_vm.submitted) ? _c('div', {
    staticClass: "has-text-centered opaque ",
    staticStyle: {
      "padding-top": "50px"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin fa-4x "
  }), _vm._v(" "), _c('p', [_vm._v("Updating Request...")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "column is-half"
  }, [_c('div', {
    staticClass: "field is-grouped",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-text",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Cancel")])]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-outlined",
    on: {
      "click": function($event) {
        _vm.previous()
      }
    }
  }, [_vm._v("Previous")])]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-link",
    on: {
      "click": function($event) {
        _vm.next()
      }
    }
  }, [_vm._v("Next")])])])])])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "has-text-centered",
    staticStyle: {
      "padding-top": "30px"
    }
  }, [_c('i', {
    staticClass: "fa fa-check fa-4x"
  }), _vm._v(" "), _c('p', [_vm._v("We have located your evidence of insurance. Please complete the fields and click next to continue.")]), _vm._v(" "), _c('br')])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1d63d2f0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/request/PropertyInformation.vue
// module id = gqOr
// module chunks = 1